<wuc-button type="clean" e2e="modal_close" modal-close-btn>
    <wuc-icon-ui icon="cross-closed"></wuc-icon-ui>
</wuc-button>

<h2 modal-title>Schadevrije jaren en mijn brommerverzekering</h2>
<div modal-content>
    <p>
        Elk jaar dat u geen schade claimt op uw brommer- of
        <wuc-link url="/scooterverzekering">scooterverzekering</wuc-link>
        = 1 schadevrij jaar. Hoe meer schadevrije jaren, hoe lager uw premie. U kunt uw schadevrije jaren gewoon
        meenemen naar een volgende verzekeraar.
    </p>

    <wuc-accordion>
        <wuc-accordion-item>
            <span slot="title">Schadevrije jaren opbouwen</span>
            <p>
                U bouwt schadevrije jaren op als u een brommer of scooter heeft verzekerd. Simpel gezegd krijgt u een
                schadevrij jaar voor ieder jaar dat u verzekerd bent en geen aanspraak maakt op de verzekering. En hoe
                meer schadevrije jaren u heeft opgebouwd, hoe hoger de korting is die u ontvangt op uw premie. Zuinig
                zijn op uw brommer of scooter kan dus goed lonen.
            </p>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">Schade melden niet altijd het slimst</span>
            <p>
                Het kan natuurlijk gebeuren: per ongeluk tegen een paaltje aan rijden. Dan kunt u kiezen: schakelt u de
                verzekering in of betaalt u de schade zelf? Meldt u een schade, dan bouwt u voor dit jaar geen
                schadevrije jaren op. Sterker nog, u valt minimaal 5 schadevrije jaren terug. Daardoor kan uw premie
                omhooggaan. U kunt dus precies uitrekenen wat goedkoper is: melden of zelf betalen (en uw schadevrije
                jaren houden).
            </p>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">Schadevrije jaren brommer meenemen</span>
            <p>In de meeste gevallen mag u uw opgebouwde schadevrije jaren gewoon meenemen van de ene verzekeraar naar
                de andere.</p>
            <b>Van een andere verzekeraar</b>
            <p>Als u overstapt met uw <a [routerLink]="salesfunnelRoutes.MopedInsurance">brommerverzekering</a> naar een
                andere verzekeringsmaatschappij, dan krijgt u bij sommige verzekeraars een zogenaamde
                royementsverklaring waar uw schadevrije jaren op staan. Die verklaring is bij InShared 5 jaar geldig.
                Sluit u bij ons een brommerverzekering af? Stuur dan binnen 2 weken de royementsverklaring op via
                <a [href]="'/' + appRoutesEnum.Question">het contactformulier</a>. Wij kijken dan uw
                schadevrije jaren na.</p>
            <b>Schadevrije jaren brommer meenemen naar auto</b>
            <p> De schadevrije jaren van uw brommer gelden alleen voor uw brommer of scooter. Het is een totaal ander
                motorrijtuig dan een auto. Daarom kunt u deze schadevrije jaren niet mee laten tellen voor uw Brommer-
                of Scooterverzekering bij InShared.</p>
        </wuc-accordion-item>
    </wuc-accordion>
</div>
